import { useState } from "react"

import Bottom from "@fuse/sharedComponents/legacyUI/Bottom"
import Navbar from "@fuse/sharedComponents/navbar/Navbar"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { EVENT_CLASS } from "@letshang/constants"

import NonTicketedEvent from "@fuse/assets/images/eventSignUp/img-non-ticketed-event-icon.svg"
import TicketedEvent from "@fuse/assets/images/eventSignUp/img-ticketed-event-icon.svg"

const eventTypes = [
  {
    id: 0,
    type: EVENT_CLASS.TICKETED_EVENT,
    icon: TicketedEvent,
    label: "Ticketed Event",
    description: "Ticketed events feature scannable tickets and include a fee",
  },
  {
    id: 1,
    type: EVENT_CLASS.NON_TICKETED_EVENT,
    icon: NonTicketedEvent,
    label: "Non-Ticketed Event",
    description:
      "Non-ticketed events don't require tickets for entry don't involve any fees",
  },
]

const EventSignUp = () => {
  const [eventType, setEventType] = useState("")
  return (
    <>
      <div
        style={{
          background: `url(/assets/bg-gradient.svg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
        }}
        className="flex flex-col"
      >
        <Navbar />
        <div className="flex-1 max-w-screen-xl self-center lg:px-8 justify-center items-center flex flex-col">
          <div className="flex flex-col items-center justify-center flex-1">
            <div className="flex flex-col items-center justify-center w-full max-w-[90%] md:max-w-[100%]">
              <div className="mx-auto flex flex-col text-center">
                <FancyText className="text-[24px] md:text-[36px] text-textPrimary">
                  <b>Create a new Event</b>
                </FancyText>

                <p className="text-[14px] md:text-[18px] text-textSecondary lg:mt-[10px]">
                  Choose your Event type
                </p>

                <div className="flex gap-4 py-16 flex-col lg:flex-row">
                  {eventTypes.map((item, index) => {
                    const isSelected = item?.type === eventType
                    return (
                      <button
                        key={index.toString()}
                        onClick={() => setEventType(item?.type)}
                        className={`bg-inherit justify-center items-center flex flex-row divide-x-2 divide-textSecondary divide-solid border-2 p-4 rounded-lg ${isSelected ? "border-primary" : "border-textSecondary"} `}
                      >
                        <img
                          src={item.icon}
                          alt="First"
                          className="hero-image px-4"
                        />

                        <div>
                          <p className="text-[14px] md:text-[18px] text-textPrimary text-left ml-[10px]">
                            {item.label}
                          </p>
                          <p className="text-[14px] md:text-[18px] text-textSecondary text-left ml-[10px]">
                            {item.description}
                          </p>
                        </div>
                      </button>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Bottom />
      </div>
    </>
  )
}

export default EventSignUp
